export type TabletNotFoundStateVariant = 'invalid-link' | 'branch-not-found'

export const NOT_FOUND_STATE_TEXTS: Record<
    TabletNotFoundStateVariant,
    { title: string; description: string }
> = {
    'invalid-link': {
        title: 'Ссылка неверная',
        description: 'Откройте планшет по ссылке филиала',
    },
    'branch-not-found': {
        title: 'Филиал не найден',
        description: 'Филиал удалён или неактивен. Обратитесь к администратору',
    },
}
